export default {
  title: 'Trigger message when Offer progress is made',
  description:
    'Send a triggered marketing message to a member when they make progress towards completion of this offer',
};
